module.exports = __webpack_public_path__ + "static/media/deck_toba.60cb4a07.jpg";